// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-description {
  background-color: #000000;
  padding-bottom: 166px;
}

.home-description__container {
  max-width: 1000px;
  margin: auto;
  display: flex;
  gap: 160px;
}

.home-description__left {
  position: relative;
  width: 516px;
  align-self: flex-start;
}

.home-description__left p {
  position: absolute;
  bottom: -30px;
  right: 0;
  color: #FFFFFF;
  font-size: 48px;
  font-style: normal;
  font-weight: 900;
  line-height: 64px;
  max-width: 428px;
}

.home-description__right {
  display: flex;
  flex-direction: column;
  gap: 48px;
  flex-shrink: 0;
}

.home-description__item {
  display: flex;
  gap: 24px;
  align-items: center;
}

.home-description__icon-box {
  border-radius: 8px;
  background: #262626;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}

.home-description__text {
  color: #FFFFFF;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}

@media only screen and (max-width: 991px) {
  .home-description__container {
    flex-direction: column;
    align-items: center;
    gap: 48px;
  }
  .home-description__left {
    align-self: unset;
    width: 100%;
    max-width: 335px;
  }
  .home-description__left svg {
    width: 120px;
  }
  .home-description__left p {
    font-size: 36px;
    line-height: 52px;
    left: 25px;
    bottom: 25px;
  }
  .home-description__item {
    gap: 16px;
  }
  .home-description__icon-box svg {
    width: 36px;
    height: 36px;
  }
  .home-description__text {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/home/components/description/Description.scss","webpack://./src/modules/home/components/description/Description.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qBAAqB;ACCvB;;ADCE;EACE,iBAAiB;EACjB,YAAY;EAGb,aAAA;ECED,UAAU;ADAV;;ACGF;EDAI,kBAAY;EAab,YAAA;EAhBA,sBAKG;ACGN;;AAEA;EDDM,kBAAc;EACd,aAAW;EACX,QAAA;EACA,cAAa;EACb,eAAa;EACb,kBAAgB;EACjB,gBAAA;ECGH,iBAAiB;EDAjB,gBAAA;ACEF;;AAEA;EAGE,aAAa;EDGX,sBAAmB;EACpB,SAAA;EAED,cAAA;ACEF;;AAEA;EDEI,aAAa;EACd,SAAA;EAGQ,mBAAO;ACElB;;AAEA;EDAI,kBAAiB;EAClB,mBAAA;EAMC,aAAA;EAGO,uBAAI;EAIT,mBAAiB;ECFrB,aDGe;ACFjB;;AAEA;EACE,cDGkB;ECFlB,eDGK;EAPF,kBAAA;ECMH,gBDIiB;ECHjB,iBDImB;ACHrB;;AAEA;EDOI;IAMW,sBAAI;IAKf,mBAAQ;IACN,SAAS;ECTb;EACA;IAGM,iBAAiB;IACrB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".home-description {\n  background-color: #000000;\n  padding-bottom: 166px;\n\n  &__container {\n    max-width: 1000px;\n    margin: auto;\n    display: flex;\n    gap: 160px;\n  }\n\n  &__left {\n    position: relative;\n    width: 516px;\n    align-self: flex-start;\n\n    p {\n      position: absolute;\n      bottom: -30px;\n      right: 0;\n      color: #FFFFFF;\n      font-size: 48px;\n      font-style: normal;\n      font-weight: 900;\n      line-height: 64px;\n      max-width: 428px;\n    }\n  }\n\n  &__right {\n    display: flex;\n    flex-direction: column;\n    gap: 48px;\n    flex-shrink: 0;\n  }\n\n  &__item {\n    display: flex;\n    gap: 24px;\n    align-items: center;\n  }\n\n  &__icon-box {\n    border-radius: 8px;\n    background: #262626;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 16px;\n  }\n\n  &__text {\n    color: #FFFFFF;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 32px;\n  }\n\n}\n\n@media only screen and (max-width: 991px) {\n  .home-description {\n    &__container {\n      flex-direction: column;\n      align-items: center;\n      gap: 48px;\n    }\n\n    &__left {\n      align-self: unset;\n      width: 100%;\n      max-width: 335px;\n\n      svg {\n        width: 120px;\n      }\n\n      p {\n        font-size: 36px;\n        line-height: 52px;\n        left: 25px;\n        bottom: 25px;\n      }\n    }\n\n    &__item {\n      gap: 16px;\n    }\n\n    &__icon-box {\n      svg {\n        width: 36px;\n        height: 36px;\n      }\n    }\n\n    &__text {\n      font-size: 24px;\n    }\n  }\n}",".home-description {\n  background-color: #000000;\n  padding-bottom: 166px;\n}\n\n.home-description__container {\n  max-width: 1000px;\n  margin: auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 160px;\n}\n\n.home-description__left {\n  position: relative;\n  width: 516px;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n}\n\n.home-description__left p {\n  position: absolute;\n  bottom: -30px;\n  right: 0;\n  color: #FFFFFF;\n  font-size: 48px;\n  font-style: normal;\n  font-weight: 900;\n  line-height: 64px;\n  max-width: 428px;\n}\n\n.home-description__right {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 48px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n\n.home-description__item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 24px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.home-description__icon-box {\n  border-radius: 8px;\n  background: #262626;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 16px;\n}\n\n.home-description__text {\n  color: #FFFFFF;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 32px;\n}\n\n@media only screen and (max-width: 991px) {\n  .home-description__container {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 48px;\n  }\n  .home-description__left {\n    -ms-flex-item-align: unset;\n        -ms-grid-row-align: unset;\n        align-self: unset;\n    width: 100%;\n    max-width: 335px;\n  }\n  .home-description__left svg {\n    width: 120px;\n  }\n  .home-description__left p {\n    font-size: 36px;\n    line-height: 52px;\n    left: 25px;\n    bottom: 25px;\n  }\n  .home-description__item {\n    gap: 16px;\n  }\n  .home-description__icon-box svg {\n    width: 36px;\n    height: 36px;\n  }\n  .home-description__text {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
